<!-- 附件预览，下载功能 -->
<template>
  <!-- 附件信息 -->
  <div class="file-content">
    <ul class="default file-info" v-if="data && data.length">
      <li class="render flex">
          <!-- <div v-if="data.fieldType===8"> -->
            <span class="label">附件：</span>
            <div class="file">
              <div class="file-item flex" v-for="(file, index) in strToArr(data)" :key="index">
                <div class="icon" :class="fileIcoPath(file)"></div>
                <a
                :href="getDownloadUrl(file.attachIndex,file.filename)"
                class="file-name"
                download
                :getDownloadUrl="file.filename"
                >
                {{formatFilename(file.filename)}}
                </a><br>
                <div class="operate">
                  <a 
                  :href="clickPreview(file)" 
                  class="view" 
                  v-if="isShowFile(file)" 
                  target="_blank"
                  >
                  预览
                  </a>
                  <a
                  :href="getDownloadUrl(file.attachIndex,file.filename)"
                  download
                  class="download"
                  target="_blank"
                  >
                  下载
                  </a>
                </div>
              </div>
            </div>
      </li>
    </ul>
  </div>
</template>
<script>
import * as api from 'src/api'

export default {
  props: {
    data: {
      type: [String, Array],
      required: true
    }
  },
  data () {
    return {
      apiUrl: api.path
    }
  },
  methods: {
    // 字符串解析成对象
    strToArr (str) {
      if (str instanceof Array) {
        return str
      }
      return window.utils.json(str)
    },
    // 通过后缀名获取关联图标
    fileIcoPath (file) {
      let ext
      if (file.ext) {
        ext = file.ext.toLowerCase()
      } else {
        ext = file.attachIndex.slice(file.attachIndex.lastIndexOf('.') + 1).toLowerCase()
      }
      return utils.getFileType(ext)
    },
    // 处理文件名过长
    formatFilename (name) {
      if (name.length > 20) {
        return name.substring(0, 10) + '...' + name.substring(name.length - 5, name.length)
      }
      return name
    },
    // 处理文件后缀为图片，txt,excel,word,pdf
    isShowFile (file) {
      let ext
      if (file.ext) {
        ext = file.ext.toLowerCase()
      } else {
        ext = file.attachIndex.slice(file.attachIndex.lastIndexOf('.') + 1).toLowerCase()
      }
      return utils.getFileViewType(ext)
    },
    // 点击预览
    clickPreview (file) {
      let reg = /attachIndex=[^&$]+/
      let fileLink
      if (reg.test(file.attachIndex)) {
        fileLink = file.attachIndex.match(reg)[0].split('=')[1]
      } else {
        fileLink = file.attachIndex
      }
      if (['office', 'pdf'].includes(this.isShowFile(file))) {
        return 'https://view.xbongbong.com/view/url?url=' + fileLink

      } else {
        return fileLink
      }
    },
    // 获取文件下载链接
    getDownloadUrl (defaultUrl, fileName) {
      let reg = /attachIndex=[^&$]+/
      let downloadUrl
      if (reg.test(defaultUrl)) {
        downloadUrl = defaultUrl
      } else {
        downloadUrl = '/cabinetFile/loadCabinetFile2.html?attachIndex=' + defaultUrl + '&fileName=' + fileName
      }
      return downloadUrl
    }
  }
}
</script>
<style lang="less" scoped>
  .file-content {
    .file-info {
      margin: 15px 0 0 15px;
      padding: 10px 0 0 0;
      border-top: 1px solid #e5ecf7;
      font-size: 14px;
      line-height: 1.6;
      text-align: justify;
      .icon {
          width: 22px;
          height: 22px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center center;
          background-image: url('../../assets/imgs/ic_file_other.png');
          &.image {
            background-image: url('../../assets/imgs/ic_file_image.png');
          }
          &.txt {
            background-image: url('../../assets/imgs/ic_file_text.png');
          }
          &.zip {
            background-image: url('../../assets/imgs/ic_file_zip.png');
          }
          &.sounds {
            background-image: url('../../assets/imgs/ic_file_sounds.png');
          }
          &.excel {
            background-image: url('../../assets/imgs/ic_file_excel.png');
          }
          &.pdf {
            background-image: url('../../assets/imgs/ic_file_pdf.png');
          }
          &.word {
            background-image: url('../../assets/imgs/ic_file_word.png');
          }
          &.ppt {
            background-image: url('../../assets/imgs/ic_file_ppt.png');
          }
          &.video {
            background-image: url('../../assets/imgs/ic_file_video.png');
          }
          &.html {
            background-image: url('../../assets/imgs/ic_file_html.png');
          }
        }
      .file-name {
          display: inline-block;
          min-width: 156px;
          margin-left: 10px;
          margin-bottom: 8px;
          color: #666;
          font-size: 13px;
        }
        .operate {
          min-width: 66px;
          margin-left: 20px;
          .view {
            float: left;
          }
          .download {
            float: right;
            padding-left: 5px;
          }
        }
    }
    .flex {
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
    }
  }
</style>





// WEBPACK FOOTER //
// attachment-preview.vue?633dea3f